export default __webpack_public_path__ + "static/media/10.f697d761.png";